export const inputToLowerCase = (input) => {
    const newInput = input;
    newInput.currentTarget.value = newInput.currentTarget.value.toLocaleLowerCase();
};

export default inputToLowerCase;
